import React, { useMemo } from 'react';
import { GenericFormPage } from '../../components/generic';
import {
  useKnowledgeBaseArticle,
  KnowledgeBaseArticle,
  useKnowledgeBaseCategories,
  buildCategoryTree,
  KnowledgeBaseCategoryTreeNode,
} from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
  formLayout,
} from './config';
import type { TreeNode } from '../../components/ui';

/** Map category tree nodes to TreeSelect TreeNode format */
function mapToTreeOptions(nodes: KnowledgeBaseCategoryTreeNode[]): TreeNode[] {
  return nodes.map((node) => ({
    value: node.id,
    label: node.name || '',
    icon: node.icon,
    children:
      node.children && node.children.length > 0 ? mapToTreeOptions(node.children) : undefined,
  }));
}

const Form: React.FC = () => {
  const { data: categories } = useKnowledgeBaseCategories();

  const configWithOptions = useMemo(() => {
    const active = (categories || []).filter((c) => c.isActive !== false);
    const tree = buildCategoryTree(active);
    const treeOptions = mapToTreeOptions(tree);

    const fields = moduleConfig.fields.map((field) => {
      if (field.name === 'categoryId') {
        return {
          ...field,
          type: 'treeSelect' as const,
          treeOptions,
        };
      }
      return field;
    });

    return { ...moduleConfig, fields };
  }, [categories]);

  return (
    <GenericFormPage<KnowledgeBaseArticle>
      useData={useKnowledgeBaseArticle}
      config={{
        ...configWithOptions,
        getInitialFormData,
        mapItemToFormData,
        formLayout,
      }}
    />
  );
};

export default Form;
